import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconLocationPin: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M8.274 4.948C7.283 5.828 6.6 7.163 6.6 9c0 .884.31 2.05.825 3.34.51 1.278 1.198 2.627 1.908 3.86a37.697 37.697 0 0 0 2.005 3.137c.262.362.487.653.662.858.175-.205.4-.496.662-.858a37.662 37.662 0 0 0 2.005-3.136c.71-1.234 1.399-2.583 1.909-3.86.514-1.292.824-2.457.824-3.341 0-1.837-.683-3.171-1.674-4.052C14.725 4.058 13.372 3.6 12 3.6c-1.372 0-2.725.458-3.726 1.348Zm-.798-.897C8.725 2.941 10.372 2.4 12 2.4c1.628 0 3.275.542 4.524 1.651C17.783 5.171 18.6 6.837 18.6 9c0 1.115-.378 2.45-.91 3.785-.537 1.347-1.255 2.748-1.982 4.014a38.864 38.864 0 0 1-2.073 3.24c-.298.413-.566.758-.782 1.004-.106.122-.21.232-.307.317-.047.041-.106.089-.173.13a.721.721 0 0 1-.373.11.72.72 0 0 1-.373-.11 1.257 1.257 0 0 1-.173-.13 3.489 3.489 0 0 1-.307-.317 14.272 14.272 0 0 1-.782-1.005A38.87 38.87 0 0 1 8.292 16.8c-.727-1.266-1.445-2.667-1.982-4.014C5.778 11.45 5.4 10.115 5.4 9c0-2.163.817-3.83 2.076-4.949Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12 10.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Zm0 1.2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      clipRule="evenodd"
    />
  </Icon>
);
